class Header {

  constructor(elem) {
    this.header = elem;
    this.cart = $('[data-header-cart-link]');
	}

  initialize() {
    // открытие окна в шапке о Бесплатной доставке
    $('[data-header-notify]').on('click', function(e) {
      let el = $(this);
      let notifyId = el.data('header-notify');
      let block = $('[data-header-notify-block="' + notifyId + '"]');

      block.slideToggle('fast')

      e.preventDefault();
    });

    this.offsetMiniCart();

    $(window).on('scroll', () => {
      this.offsetMiniCart();
    });
	}

  offsetMiniCart() {
    let header = $('[data-header-sticky]');
    let cart = $('[data-header-cart]');
    let top = header.offset().top;
    let scroll = $(document).scrollTop();

    if (scroll < top) {
      cart.css({'bottom': `calc(-100vh + 100% + ${42 - scroll}px)`})
    } else {
      cart.removeAttr('style')
    }
  }
}

export {Header};

$(window).on('load', () => {
  if ($('[data-header]').length > 0) {
    let header = new Header('[data-header]');
    header.initialize();
  }
});
